// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"107":"058a790dcfd7f6eb","354":"3f73a19146de656d"}[chunkId] + ".js";
};